export const EmailColoredIcon = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 44.107c10.912 0 19.758-8.846 19.758-19.757S34.912 4.592 24 4.592 4.242 13.438 4.242 24.35 13.088 44.107 24 44.107"
      fill="#05A3D6"
    />
    <path
      d="M34 16.016H14a.833.833 0 0 0-.833.833v14.167a1.667 1.667 0 0 0 1.667 1.667h18.333a1.667 1.667 0 0 0 1.667-1.667V16.85a.833.833 0 0 0-.834-.833m-10 8.87-7.857-7.203h15.715zm-3.05-.537-6.116 5.606v-11.21zm1.233 1.13 1.25 1.152a.834.834 0 0 0 1.127 0l1.25-1.151 6.041 5.536H16.143zm4.868-1.13 6.116-5.606v11.213z"
      fill="#fff"
    />
  </svg>
);

export default EmailColoredIcon;
